import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'
import Sidebar from '../newMenu/menuSidebar'
import '../../../../images/leroy_no_desc.png'
import HeaderUser from './HeaderUser'
import HeaderNotification from './HeaderNotification'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { logout } from '../../../actions/auth'
import { setSelectedItem } from '../../../actions/menu'
import { fetchCurrentBase } from '../../../actions/systemParameters'

function toTitleCase(str) {
  return str
    ? str.replace(/\w\S*/g, (txt) =>
        txt.length <= 2
          ? txt.toLowerCase()
          : txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
      )
    : ''
}

const Header = ({
  setSelectedItem,
  auth,
  logoutFunc,
  translate,
  systemParametersReducer: sysParam,
  fetchCurrentBase,
}) => {
  const [didFirstSubmit, setFirstSubmit] = useState(false)

  if (!(sysParam && sysParam.currentBase) && !didFirstSubmit) {
    fetchCurrentBase(auth && auth.user && auth.user.dsToken)
    setFirstSubmit(true)
  }

  return (
    <header className='ubuntu-font main-header navigation header-height'>
      <Sidebar user={auth.user} />

      <Link
        onClick={() => setSelectedItem({})}
        to='/'
        className='margin-div-header'
      >
        <img
          className='new-header-logo'
          src={'../../../../images/leroy_no_desc.png'}
        />
      </Link>

      <div className='portal-title'>
        <h3>{translate('header.mob.title')}</h3>
        {sysParam && sysParam.currentBase && sysParam.currentBase !== ' ' && (
          <span>{sysParam.currentBase}</span>
        )}
      </div>

      {auth.isAuthenticated && (
        <div className='user-menu'>
          <HeaderNotification />
          <HeaderUser
            user={toTitleCase(
              auth.user.fullName && auth.user.fullName.split(' ')[0]
            )}
            logout={logoutFunc}
            translate={translate}
          />
        </div>
      )}
    </header>
  )
}

Header.propTypes = {
  auth: PropTypes.object.isRequired,
  logoutFunc: PropTypes.func,
  translate: PropTypes.func.isRequired,
  searchFiliais: PropTypes.func,
  systemParametersReducer: PropTypes.object,
  fetchCurrentBase: PropTypes.func,
  setSelectedItem: PropTypes.func,
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    { setSelectedItem, fetchCurrentBase, logoutFunc: logout },
    dispatch
  )

export default connect(
  ({ auth, systemParametersReducer }) => ({ auth, systemParametersReducer }),
  mapDispatchToProps
)(Header)
